document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('book-popup');

  if(!popup) return

  const closeBtn = document.getElementById('close-book-popup');
  const form = document.getElementById('book-popup-form');
  const prevBtn = document.getElementById('book-popup-prev');
  const nextBtn = document.getElementById('book-popup-next');
  const monthLabel = document.getElementById('book-popup-month-label');
  const datesGrid = document.getElementById('book-popup-dates');
  const checkinLabel = document.getElementById('book-popup-checkin-label');
  const checkoutLabel = document.getElementById('book-popup-checkout-label');

  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const HOTEL_ID = form.dataset.hotelId;

  let today = new Date();
  today.setHours(0, 0, 0, 0);

  const seasonStartStr = form.dataset.seasonStart || '';
  let seasonStart = null;
  if (seasonStartStr) {
    const parts = seasonStartStr.split('-'); // ['YYYY','MM','DD']
    if (parts.length === 3) {
      const candidate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      candidate.setHours(0, 0, 0, 0);
      if (candidate > today) seasonStart = candidate;
    }
  }

  const effectiveMin = seasonStart || today;
  let viewYear = effectiveMin.getFullYear();
  let viewMonth = effectiveMin.getMonth();
  let checkin = null;
  let checkout = null;

  function getOpeners() {
    return document.querySelectorAll('a[href="#book-popup"]');
  }

  function formatDate(d) {
    return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
  }

  function renderCalendar() {
    monthLabel.textContent = MONTHS[viewMonth] + ' ' + viewYear;
    prevBtn.disabled = viewYear === effectiveMin.getFullYear() && viewMonth === effectiveMin.getMonth();
    datesGrid.innerHTML = '';

    const startDay = new Date(viewYear, viewMonth, 1).getDay();
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

    for (let i = 0; i < startDay; i++) {
      datesGrid.appendChild(document.createElement('span'));
    }

    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(viewYear, viewMonth, d);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = d;
      btn.setAttribute('aria-label', MONTHS[viewMonth] + ' ' + d + ', ' + viewYear);

      if (date < effectiveMin) {
        btn.disabled = true;
        btn.classList.add('past');
      } else {
        if (checkin && date.getTime() === checkin.getTime()) {
          btn.classList.add('checkin');
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', btn.getAttribute('aria-label') + ' (check-in)');
        }
        if (checkout && date.getTime() === checkout.getTime()) {
          btn.classList.add('checkout');
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', btn.getAttribute('aria-label') + ' (check-out)');
        }
        if (checkin && checkout && date > checkin && date < checkout) {
          btn.classList.add('in-range');
        }

        btn.addEventListener('click', function () {
          const focusDay = d;
          if (!checkin || (checkin && checkout)) {
            checkin = date;
            checkout = null;
          } else if (date <= checkin) {
            checkin = date;
            checkout = null;
          } else {
            checkout = date;
          }
          updateLabels();
          renderCalendar();
          const refocused = Array.from(datesGrid.querySelectorAll('button')).find(b => parseInt(b.textContent, 10) === focusDay);
          if (refocused) refocused.focus();
        });
      }

      datesGrid.appendChild(btn);
    }
  }

  function updateLabels() {
    checkinLabel.textContent = 'Check-in: ' + (checkin ? formatDate(checkin) : '—');
    checkoutLabel.textContent = 'Check-out: ' + (checkout ? formatDate(checkout) : '—');
  }

  function openPopup() {
    renderCalendar();
    updateLabels();
    popup.getBoundingClientRect();
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    getOpeners().forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
    closeBtn.focus();
    popup.addEventListener('focusout', onFocusOut);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    getOpeners().forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    popup.removeEventListener('focusout', onFocusOut);
  }

  function onFocusOut() {
    setTimeout(function () {
      const active = document.activeElement;
      if (active === document.body || active === null) return;
      if (!popup.contains(active)) {
        closePopup();
      }
    }, 0);
  }

  // Prevent browser typeahead from jumping focus to the first matching date button
  // when the user presses a digit or character key while navigating the calendar.
  datesGrid.addEventListener('keydown', function (e) {
    if (e.key.length === 1 && e.key !== ' ' && !e.ctrlKey && !e.metaKey && !e.altKey) {
      e.preventDefault();
    }
  });

  prevBtn.addEventListener('click', function () {
    if (viewYear === effectiveMin.getFullYear() && viewMonth === effectiveMin.getMonth()) return;
    viewMonth--;
    if (viewMonth < 0) { viewMonth = 11; viewYear--; }
    renderCalendar();
  });

  nextBtn.addEventListener('click', function () {
    viewMonth++;
    if (viewMonth > 11) { viewMonth = 0; viewYear++; }
    renderCalendar();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!checkin || !checkout) return;
    const rooms = document.getElementById('book-popup-rooms').value;
    const guests = document.getElementById('book-popup-guests').value;
    const ci = encodeURIComponent(formatDate(checkin));
    const co = encodeURIComponent(formatDate(checkout));
    window.open('https://res.windsurfercrs.com/ibe/index.aspx?hotelID=' + HOTEL_ID + '&checkin=' + ci + '&checkout=' + co + '&rooms=' + rooms + '&adults=' + guests, '_blank');
  });

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  // Event delegation — works regardless of when/where opener links are in the DOM
  document.addEventListener('click', function (e) {
    const opener = e.target.closest('a[href="#book-popup"]');
    if (opener) {
      e.preventDefault();
      popup.classList.contains('is-open') ? closePopup() : openPopup();
      return;
    }
    const path = e.composedPath();
    if (popup.classList.contains('is-open') && !path.includes(popup)) {
      closePopup();
    }
  });

  // Init opener aria attributes
  getOpeners().forEach(function (el) {
    el.setAttribute('aria-expanded', 'false');
    el.setAttribute('aria-controls', 'book-popup');
  });
});
